import { render, staticRenderFns } from "./CardPelaporComponent.vue?vue&type=template&id=28edf19c&scoped=true"
import script from "./CardPelaporComponent.vue?vue&type=script&lang=js"
export * from "./CardPelaporComponent.vue?vue&type=script&lang=js"
import style0 from "./CardPelaporComponent.vue?vue&type=style&index=0&id=28edf19c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28edf19c",
  null
  
)

export default component.exports